import { Markdown } from '@/components/Markdown'
import type { TemplateDetail } from '@/lib/scientific'

export function InitialAgentReview({ data, developer, busy, retry }: {
  data: TemplateDetail; developer: boolean; busy: boolean; retry: () => void
}) {
  const review = data.initial_agent_review
  if (!review) return null
  const job = review.job
  const failed = job?.status === 'failed' || !job && review.preparation?.status === 'failed'
  const active = [3, 4].includes(data.template.stage) && !data.template.importing && data.template.lifecycle !== 'retired' && !data.template.qc_return
  return <section className="box" aria-label="Agent review">
    <h2>Agent review <span className="chip">Advisory</span></h2>
    <p className="muted small">Checks every compiled task and shared dependency. {data.template.pre_rollout_review ? 'Reviews the package before rollout evidence is available.' : 'Includes the frozen execution evidence and coverage.'} This recommendation does not gate rollouts or publication.</p>
    <p role="status">{job ? `Review: ${job.status}` : `Preparing materials: ${review.preparation?.status ?? 'queued'}`}</p>
    {job?.report && <><p>Recommendation: {job.report.verdict === 'ready' ? 'Ready' : 'Not ready'}</p><Markdown source={job.report.feedback} /></>}
    {failed && <p className="err">{job?.error ?? review.preparation?.error}</p>}
    {developer && failed && active && <button disabled={busy} onClick={retry}>Retry agent review</button>}
  </section>
}
